import React, { useState, useEffect, memo } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { Modal, OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";
import { BsCheckCircle, BsExclamationOctagon } from "react-icons/bs";
import pencilWatilist from "../../../assets/images/pencil-waitlist.svg";
import waitlistDelete from "../../../assets/images/waitlist-delete.svg";
import waitlistCalendar from "../../../assets/images/waitlist-calendar.svg";
import { openToModifyWaitlist } from "../../../StateManagement/Reducers/ScheduleWidgetState";

import {
  Table,
  TableHeadCell,
  TableBody,
  TableBodyCell,
  TableHead,
  TableRow,
  Image,
} from "../../setting/PatientPortalSettings/StyledComponents";
import { useDispatch, useSelector } from "react-redux";

import Emp_data_pic from "../../../assets/images/Emp_data_pic.png";
import CustomSuffixIcon from "../../popups/CustomSuffixIcon";
import { globalColor, globalFont } from "../../utils/RepeatFunctions/Schedule";
import { Button, Div, Span } from "../../../StyledComponents";
import { SelectAnt } from "../../../Modules/Schedule/PracticeDashboard/styles";
import WaitlistModal from "./WaitlistModal";
import axiosInstance from "../../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import NewAppointment from "../../popups/NewAppointment";
import Loader from "../../popups/Loading";
import { useLocation, useHistory } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../../popups/GetStartedPopup";

const { Option } = SelectAnt;

export function to12Hour(timeString) {
  if (!timeString) return "N/A";

  const [hour, minute] = timeString.split(":");
  const h = parseInt(hour, 10);

  const suffix = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 || 12;

  // Add leading zero to hour
  const formattedHour = hour12.toString().padStart(2, "0");

  return `${formattedHour}:${minute} ${suffix}`;
}

const WaitlistTable = ({ showAddModal, setAddModalShow }) => {
  // ------------------------------ State and Variables START--------------------------------------------------- //
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  var editDataFromNotify = useSelector(
    (state) => state.ScheduleWidget.modifyWaitlistAppointmentData,
  );
  const [listFullData, setListFullData] = useState([]);

  // Load More States
  const [showLoading, setShowLoading] = useState("none");
  const [loadFlag, setLoadFlag] = useState(0);
  const [offset, setOffset] = useState(0);
  const [displayData, setDisplayData] = useState([]);
  const limit = 15; // Initial load limit

  // Filter states
  const [filterPatient, setFilterPatient] = useState("");
  const [filterProvider, setFilterProvider] = useState("");
  const [filterFacility, setFilterFacility] = useState("");
  const [filterApptType, setFilterApptType] = useState("");
  const [filterPriority, setFilterPriority] = useState("");
  const [fromDate, setFromDate] = useState(moment().subtract(7, "days"));
  const [toDate, setToDate] = useState(moment());

  const [modalAlertShow, setModalAlertShow] = useState(false);
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [successModalAlertShow, setSuccessModalAlertShow] = useState(false);
  const [editData, setEditData] = useState(null);
  const [editId, setEditId] = useState(0);
  const [newApptData, setNewApptData] = useState(null);
  const [showNewApptPopup, setShowNewApptPopup] = useState(false);

  const dtFormat = localStorage.getItem("dateFormat") || "MM/DD/YYYY";

  // Dropdown options
  const [patients, setPatients] = useState([]);
  const [providers, setProviders] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [apptProfiles, setApptProfiles] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  const user_id = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  const group_id = Decrypt_Value(localStorage.getItem("group_id"), "vozo");

  const apptTypes = [
    { id: 0, name: "Appointment" },
    { id: 1, name: "Walk-in" },
    { id: 2, name: "Telehealth" },
  ];

  const priorities = [
    { id: 1, name: "Urgent" },
    { id: 2, name: "High" },
    { id: 3, name: "Medium" },
    { id: 4, name: "Low" },
  ];

  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const popupStep = searchParams.get("step");
  const [waitlistCalendarIconNode, setWaitlistCalendarIconNode] = useState(null);
  const waitlistCalendarIconRef = (node) => {
    if (node !== null) {
      setWaitlistCalendarIconNode(node);
    }
  }; 
   const dataToRender = displayData;

  // ------------------------------ State and Variables END--------------------------------------------------- //

  // ------------------------------ Functions START---------------------------------------------------//

  const fetchWaitlistData = async (loadMore = false, filters = {}) => {
    if (!loadMore) {
      setLoading(true);
      setOffset(0);
    }

    try {
      const currentOffset = loadMore ? offset : 0;

      // Build query parameters as individual fields (not nested object)
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const requestData = {
        limit: limit,
        offset: currentOffset,
        authorized: authorized,
        main_pro: main_pro,
        userID: user_id,
        pat_share: storedNames.pat_share,
        owner_id: owner_id,
        group_id: group_id,
        // Add filter parameters directly
        ...filters,
        timeZone: timeZone,
      };

      // Remove empty filter values to avoid conflicts
      Object.keys(requestData).forEach((key) => {
        if (
          requestData[key] === "" ||
          requestData[key] === null ||
          requestData[key] === undefined
        ) {
          delete requestData[key];
        }
      });

      // Encrypt the individual parameters
      const encryptedFilters = Encrypt_Value(requestData, "vozo");

      const response = await axiosInstance.post(
        "/vozo/appointment_waitlist/read",
        encryptedFilters,
      );

      const decryptedData = Decrypt_Value(response.data, "vozo");

      if (decryptedData && decryptedData.success) {
        setListFullData(decryptedData.data);
        const newData = decryptedData.data || [];
        const total = decryptedData.total || 0;

        setTotalRecords(total);

        if (loadMore) {
          // For load more, append to existing data
          const updatedData = [...displayData, ...newData];
          setDisplayData(updatedData);

          // Update offset - this should be the next starting position
          const newOffset = currentOffset + newData.length;
          setOffset(newOffset);

          // Check if there's more data to load
          const hasMoreData = newOffset < total;
          setHasMore(hasMoreData);
          setShowLoading(hasMoreData ? "block" : "none");
        } else {
          // Initial load
          setDisplayData(newData);
          // Set offset to the number of items loaded for next load more
          setOffset(newData.length);

          // Check if there's more data to load
          const hasMoreData = newData.length < total;
          setHasMore(hasMoreData);
          setShowLoading(hasMoreData ? "block" : "none");
        }
      } else {
        if (!loadMore) {
          setDisplayData([]);
          setOffset(0);
          setHasMore(false);
          setShowLoading("none");
          setTotalRecords(0);
        }
      }
    } catch (error) {
      console.error("Error fetching waitlist data:", error);
      if (!loadMore) {
        setDisplayData([]);
        setOffset(0);
        setHasMore(false);
        setShowLoading("none");
        setTotalRecords(0);
      }
    } finally {
      setLoading(false);
      setLoadFlag(0);
    }
  };

  const handleSearch = async () => {
    const filters = {};

    // Convert filter values to match PHP expected format
    if (filterPatient) filters.patient_id = filterPatient;
    if (filterProvider) filters.provider = filterProvider;
    if (filterFacility) filters.facility = filterFacility;
    if (filterApptType) filters.appt_type = filterApptType;
    if (filterPriority || filterPriority === 0)
      filters.priority = filterPriority;
    if (fromDate) filters.start_date = fromDate.format("YYYY-MM-DD");
    if (toDate) filters.end_date = toDate.format("YYYY-MM-DD");

    await fetchWaitlistData(false, filters);
  };

  const loadMoreData = () => {
    if (loadFlag === 1 || !hasMore) {
      return;
    }

    setLoadFlag(1);

    const filters = {};
    if (filterPatient) filters.patient_id = filterPatient;
    if (filterProvider) filters.provider = filterProvider;
    if (filterFacility) filters.facility = filterFacility;
    if (filterApptType) filters.appt_type = filterApptType;
    if (filterPriority || filterPriority === 0)
      filters.priority = filterPriority;
    if (fromDate) filters.start_date = fromDate.format("YYYY-MM-DD");
    if (toDate) filters.end_date = toDate.format("YYYY-MM-DD");

    fetchWaitlistData(true, filters);
  };

  const firstLoadWaitlistData = async () => {
    let filters = {};
    if (fromDate) filters.start_date = fromDate.format("YYYY-MM-DD");
    if (toDate) filters.end_date = toDate.format("YYYY-MM-DD");
    setOffset(0);
    await fetchWaitlistData(false, filters);
  };

  const handleDateRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      setFromDate(dates[0]);
      setToDate(dates[1]);
    } else {
      setFromDate(null);
      setToDate(null);
    }
  };

  const truncateText = (text, maxLength = 20) => {
    if (!text) return "";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "available":
        return "badge text-success";
      case "pending":
        return "badge text-primary";
      case "expired":
        return "badge text-danger";
      default:
        return "badge text-warning";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "available":
        return "Available";
      case "accepted":
        return "Accepted";
      case "pending":
        return "Pending";
      case "expired":
        return "Expired";
      default:
        return "Pending";
    }
  };

  const handleEditAppointment = (appointment) => {
    setEditData(appointment);
    setEditId(appointment.id);
    setAddModalShow(true);
  };

  const deleteWaitlistEntry = async (waitlistId) => {
    try {
      const response = await axiosInstance.delete(
        `/vozo/appointment_waitlist/delete?id=${waitlistId}`,
      );
      const decryptedData = Decrypt_Value(response.data, "vozo");

      if (decryptedData && decryptedData.success) {
        console.log("Waitlist entry deleted successfully");
      } else {
        console.error("Failed to delete waitlist entry:", decryptedData.error);
      }
    } catch (error) {
      console.error("Error deleting waitlist entry:", error);
    }
  };

  const handleDeleteAppointment = async (appointment) => {
    if (
      window.confirm(
        `Are you sure you want to delete waitlist appointment for ${
          appointment.patient_name || "this patient"
        }?`,
      )
    ) {
      try {
        const response = await axiosInstance.delete(
          `/vozo/appointment_waitlist/delete?id=${appointment.id}`,
        );
        const decryptedData = Decrypt_Value(response.data, "vozo");

        if (decryptedData && decryptedData.success) {
          setAlertMsg("Waitlist appointment deleted successfully");
          setSuccessModalAlertShow(true);
          firstLoadWaitlistData(); // Refresh data
        } else {
          setAlertMsg(decryptedData.error || "Failed to delete appointment");
          setModalAlertShow(true);
        }
      } catch (error) {
        console.error("Error deleting appointment:", error);
        setAlertMsg("Error deleting appointment");
        setModalAlertShow(true);
      } finally {
        setTimeout(() => {
          setSuccessModalAlertShow(false);
          setTimeout(() => {
            setAlertMsg("");
          }, 1000);
        }, 1500);
      }
    }
  };

  const handleAcceptAppointment = async (appointment) => {
    try {
      const updateData = {
        appointment_id: appointment.id,
        status: "",
        accepted: 1,
        patient_id: appointment.patient_id,
        provider_id: String(appointment.provider),
        facility_id: String(appointment.facility),
        appointment_date: appointment.appt_date,
        start_time: appointment.pref_start_time,
        end_time: appointment.pref_end_time,
        patient_name: appointment.patient_name,
        facility_name: appointment.facility_name,
        provider_name: appointment.provider_name,
        speciality: appointment.speciality || "",
        reason: appointment.reason || "",
        appt_type: appointment.appt_type,
        priority: appointment.priority,
        profile_id: appointment.appt_profile
          ? String(appointment.appt_profile)
          : "",
        waitlist_id: appointment.id, // Add this to track which waitlist entry to delete
      };

      setNewApptData(updateData);
      setShowNewApptPopup(true);
    } catch (error) {
      console.error("Error accepting appointment:", error);
      setAlertMsg("Error accepting appointment");
      setModalAlertShow(true);
    }
  };

  const fetchDropdownData = async () => {
    try {
      // Fetch patients
      const patientsResponse = await axiosInstance.get("/vozo/patientsearch");
      const decryptedPatients = Decrypt_Value(patientsResponse.data, "vozo");
      setPatients(decryptedPatients || []);

      // // Fetch providers
      const providersResponse = await axiosInstance.get("/vozonew/provider");
      const decryptedProviders = Decrypt_Value(providersResponse.data, "vozo");
      setProviders(decryptedProviders || []);

      // // Fetch facilities
      const facilitiesResponse = await axiosInstance.get("/vozonew/facility");
      const decryptedFacilities = Decrypt_Value(
        facilitiesResponse.data,
        "vozo",
      );
      setFacilities(decryptedFacilities || []);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  const dataFetch = () => {
    firstLoadWaitlistData();
  };
  const openEdit = async (pc_eid) => {
    try {
      const requestData = {
        limit,
        offset: 0,
        authorized,
        main_pro,
        userID: user_id,
        pat_share: storedNames.pat_share,
        owner_id,
        group_id,
        method: "edit",
      };

      // Encrypt the data before sending
      const encryptedFilters = Encrypt_Value(requestData, "vozo");

      // Send POST request
      const response = await axiosInstance.post(
        "/vozo/appointment_waitlist/read",
        encryptedFilters,
      );

      // Decrypt the response
      const decryptedData = Decrypt_Value(response.data, "vozo");

      console.log("Decrypted response:", decryptedData);
      if (decryptedData.find((item) => item.id === pc_eid)) {
        handleEditAppointment(decryptedData.find((item) => item.id === pc_eid));
      }
      // return decryptedData; // ✅ Return the data so the caller can use it
    } catch (error) {
      console.error("Error while fetching appointment waitlist:", error);
      throw error; // optional: rethrow or handle error gracefully
    }
  };
  // ------------------------------ Functions END---------------------------------------------------//

  // ------------------------------ useEffect START---------------------------------------------------//
  useEffect(() => {
    firstLoadWaitlistData();
    fetchDropdownData();
  }, []);

  useEffect(() => {
    if ((popupStep === "waitlist6" || popupStep === "waitlist7") && !loading && displayData.length === 0) {
      setDisplayData([
        {
          id: "dummy-1",
          patient_id: "1",
          patient_name: "Testpatient number1",
          appt_profile: "1",
          appt_type: 0,
          facility: "1",
          facility_name: "vinthyen",
          provider: "1",
          provider_name: "RAJESH",
          appt_date: "2026-06-12",
          pref_start_time: "10:50:00",
          pref_end_time: "11:05:00",
          priority: 3,
          status: 0,
          speciality: "Dental Health",
          reason: "Normal checkup",
        },
      ]);
    }
  }, [popupStep, loading, displayData.length]);

  useEffect(() => {
    if (popupStep !== "waitlist6" && popupStep !== "waitlist7") {
      setDisplayData((prev) => {
        if (prev.some((item) => item.id === "dummy-1")) {
          return prev.filter((item) => item.id !== "dummy-1");
        }
        return prev;
      });
    }
  }, [popupStep]);

  useEffect(() => {
    if (popupStep === "waitlist7" && !showNewApptPopup && displayData && displayData.length > 0) {
      handleAcceptAppointment(displayData[0]);
    }
  }, [popupStep, showNewApptPopup, displayData]);

  // Reset edit data when modal closes
  useEffect(() => {
    if (!showAddModal) {
      setEditData(null);
      setEditId(0);
    }
  }, [showAddModal]);
  useEffect(() => {
    if (editDataFromNotify?.pc_eid) {
      openEdit(editDataFromNotify?.pc_eid);
    }
  }, [editDataFromNotify, listFullData]);
  // ------------------------------ useEffect END---------------------------------------------------//

  return (
    <>
      {/* Table Header with Actions */}
      <Div
        className="appointment-table-header d-flex"
        style={{ display: "flex", flexDirection: "column" }}
      >
        {/* Filter Section */}
        <Div
          marginBottom="26px"
          padding="10px 20px"
          className="appointment-management-filters"
          display="flex"
          gap="10px"
          alignItems="center"
          style={{ flexWrap: "wrap" }}
        >
          {/* Patient Filter */}
          <Div className="filter-item" width="200px">
            <SelectAnt
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              suffixIcon={<CustomSuffixIcon />}
              placeholder="Patient"
              className="w-100"
              value={filterPatient}
              onChange={setFilterPatient}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              <Option value="">All Patients</Option>
              {patients.map((patient) => (
                <Option key={patient.pid} value={patient.pid}>
                  {patient.title || patient.name}
                </Option>
              ))}
            </SelectAnt>
          </Div>

          {/* Provider Filter */}
          <Div className="filter-item" width="200px">
            <SelectAnt
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              suffixIcon={<CustomSuffixIcon />}
              placeholder="Provider"
              className="w-100"
              value={filterProvider}
              onChange={setFilterProvider}
            >
              <Option value="">All Providers</Option>
              {providers.map((provider) => (
                <Option key={provider.id} value={provider.id}>
                  {provider.text || provider.name}
                </Option>
              ))}
            </SelectAnt>
          </Div>

          {/* Facility Filter */}
          <Div className="filter-item" width="200px">
            <SelectAnt
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              suffixIcon={<CustomSuffixIcon />}
              placeholder="Facility"
              className="w-100"
              value={filterFacility}
              onChange={setFilterFacility}
            >
              <Option value="">All Facilities</Option>
              {facilities.map((facility) => (
                <Option key={facility.id} value={facility.id}>
                  {facility.name}
                </Option>
              ))}
            </SelectAnt>
          </Div>

          {/* Appointment Type Filter */}
          <Div className="filter-item" width="200px">
            <SelectAnt
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              suffixIcon={<CustomSuffixIcon />}
              placeholder="Appointment Type"
              className="w-100"
              value={filterApptType ?? ""}
              onChange={setFilterApptType}
            >
              <Option value="">All Types</Option>
              {apptTypes.map((type) => (
                <Option key={type.id} value={String(type.id)}>
                  {type.name}
                </Option>
              ))}
            </SelectAnt>
          </Div>

          {/* Date Range Filter */}
          <div
            className="filter-item"
            style={{
              width: "280px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <DatePicker
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              placeholder="Start Date"
              value={fromDate}
              onChange={(date) => handleDateRangeChange([date, toDate])}
              format={dtFormat}
              allowClear={false}
              inputReadOnly={true}
              style={{
                width: "45%",
                height: "42px",
                fontSize: "14px",
                padding: "8px 12px",
              }}
            />
            <span
              style={{
                color: "#666",
                fontSize: "14px",
                minWidth: "20px",
                textAlign: "center",
              }}
            >
              to
            </span>
            <DatePicker
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              placeholder="End Date"
              value={toDate}
              onChange={(date) => handleDateRangeChange([fromDate, date])}
              format={dtFormat}
              allowClear={false}
              inputReadOnly={true}
              style={{
                width: "45%",
                height: "42px",
                fontSize: "14px",
                padding: "8px 12px",
              }}
            />
          </div>

          {/* Priority Filter */}
          <Div className="filter-item" width="150px">
            <SelectAnt
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              suffixIcon={<CustomSuffixIcon />}
              placeholder="Priority"
              className="w-100"
              value={filterPriority}
              onChange={setFilterPriority}
            >
              <Option value="">All Priorities</Option>
              {priorities.map((priority) => (
                <Option key={priority.id} value={priority.id}>
                  {priority.name}
                </Option>
              ))}
            </SelectAnt>
          </Div>

          {/* Search Button */}
          <Div className="filter-item">
            <Button
              background={globalColor}
              borderRadius="4px"
              color="#FFFFFF"
              height="34px"
              width="120px"
              border={`1px solid ${globalColor}`}
              hoverBackColor="#005FB2"
              className="save_active"
              onClick={handleSearch}
              disabled={loading}
            >
              Search
            </Button>
          </Div>
        </Div>
      </Div>

      {/* Loading State */}
      {loading && displayData.length === 0 && <Loader />}

      {/* Table */}
      <Div className="table-responsive">
        <Table>
          <TableHead>
            <TableRow className="tr-no" height="56px" background="#F1F5F8">
              <TableHeadCell
                padding="12px 16px"
                fontFamily={globalFont}
                lineHeight="19px"
                color={globalColor}
                width="15%"
                textAlign="left"
              >
                Patient
              </TableHeadCell>
              <TableHeadCell
                padding="12px 16px"
                fontFamily={globalFont}
                lineHeight="19px"
                color={globalColor}
                width="12%"
                textAlign="left"
              >
                Appt Type
              </TableHeadCell>
              <TableHeadCell
                padding="12px 16px"
                fontFamily={globalFont}
                // fontWeight="600"
                lineHeight="19px"
                color={globalColor}
                width="12%"
                textAlign="left"
              >
                Facility
              </TableHeadCell>
              <TableHeadCell
                padding="12px 16px"
                fontFamily={globalFont}
                lineHeight="19px"
                color={globalColor}
                width="15%"
                textAlign="left"
              >
                Provider
              </TableHeadCell>
              <TableHeadCell
                padding="12px 16px"
                fontFamily={globalFont}
                lineHeight="19px"
                color={globalColor}
                width="10%"
                textAlign="left"
              >
                Appt Date
              </TableHeadCell>
              <TableHeadCell
                padding="12px 16px"
                fontFamily={globalFont}
                lineHeight="19px"
                color={globalColor}
                width="10%"
                textAlign="left"
              >
                Pref Time
              </TableHeadCell>
              <TableHeadCell
                padding="12px 16px"
                fontFamily={globalFont}
                lineHeight="19px"
                color={globalColor}
                width="8%"
                textAlign="left"
              >
                Priority
              </TableHeadCell>
              <TableHeadCell
                padding="12px 16px"
                fontFamily={globalFont}
                lineHeight="19px"
                color={globalColor}
                width="8%"
                textAlign="left"
              >
                Status
              </TableHeadCell>
              <TableHeadCell
                padding="12px 16px"
                fontFamily={globalFont}
                lineHeight="19px"
                color={globalColor}
                textAlign="center"
              >
                Action
              </TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody className="last-child-brdr">
            {dataToRender.length !== 0
              ? dataToRender.map((appointment, index) => (
                  <TableRow
                    key={appointment.id}
                    className="schedule-head-row tr-no"
                  >
                    <TableBodyCell padding="12px 16px" textAlign="left">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-${appointment.id}`}>
                            {appointment.patient_name || "N/A"}
                          </Tooltip>
                        }
                      >
                        <Span
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                            maxWidth: "150px",
                          }}
                        >
                          {truncateText(appointment.patient_name || "N/A", 20)}
                        </Span>
                      </OverlayTrigger>
                    </TableBodyCell>
                    <TableBodyCell padding="12px 16px" textAlign="left">
                      {appointment.appt_type === 1
                        ? "Walk-in"
                        : appointment.appt_type === 2
                          ? "Telehealth"
                          : appointment.appt_type === 0
                            ? "Appointment"
                            : "N/A"}
                    </TableBodyCell>
                    <TableBodyCell padding="12px 16px" textAlign="left">
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{appointment.facility_name}</Tooltip>}
                      >
                        <Span
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                            maxWidth: "150px",
                          }}
                        >
                          {truncateText(appointment.facility_name, 15)}
                        </Span>
                      </OverlayTrigger>
                    </TableBodyCell>
                    <TableBodyCell padding="12px 16px" textAlign="left">
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{appointment.provider_name}</Tooltip>}
                      >
                        <Span
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                            maxWidth: "150px",
                          }}
                        >
                          {truncateText(appointment.provider_name, 15)}
                        </Span>
                      </OverlayTrigger>
                    </TableBodyCell>
                    <TableBodyCell padding="12px 16px" textAlign="left">
                      {appointment.appt_date
                        ? moment(appointment.appt_date).format(dtFormat)
                        : "N/A"}
                    </TableBodyCell>
                    <TableBodyCell padding="12px 16px" textAlign="left">
                      {to12Hour(appointment.pref_start_time) || "N/A"} -{" "}
                      {to12Hour(appointment.pref_end_time) || "N/A"}
                    </TableBodyCell>
                    <TableBodyCell padding="12px 16px" textAlign="left">
                      <span className="badge">
                        {priorities.find(
                          (pri) => pri.id == appointment.priority,
                        )?.name || "N/A"}
                      </span>
                    </TableBodyCell>
                    <TableBodyCell padding="12px 16px" textAlign="left">
                      <span className={getStatusBadgeClass(appointment.status)}>
                        {getStatusText(appointment.status)}
                      </span>
                    </TableBodyCell>
                    <TableBodyCell padding="12px 16px" textAlign="center">
                      <div
                        className="dropdown"
                        style={{
                          display: "flex",
                          gap: "8px",
                          justifyContent: "center",
                          alignItems: "center",
                            position: "relative",
                        }}
                      >
                        <img
                          src={pencilWatilist}
                          alt="edit"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleEditAppointment(appointment)}
                        />
                        <img
                          src={waitlistDelete}
                          alt="delete"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeleteAppointment(appointment)}
                          />
                                            {popupStep === "waitlist6" && index === 0 && (() => {
                          const targetRect = waitlistCalendarIconNode ? waitlistCalendarIconNode.getBoundingClientRect() : null;
                          const popupWidth = 350;
                          const popupMinHeight = 180;
                          const leftGap = 7;

                          return targetRect ? (
                            <div
                              className="waitlist-step6-popup-container"
                              style={{
                                position: "fixed",
                                left: `${targetRect.left - popupWidth - leftGap}px`,
                                top: `${targetRect.top - (popupMinHeight / 2) + (targetRect.height / 2)}px`,
                                zIndex: 1060,
                                backgroundColor: "#ffffff",
                                borderRadius: "8px",
                                boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
                                padding: "20px 18px 16px 18px",
                                width: `${popupWidth}px`,
                                minHeight: `${popupMinHeight}px`,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  right: "-10px",
                                  top: "40%",
                                  marginTop: "-10px",
                                  width: 0,
                                  height: 0,
                                  borderTop: "10px solid transparent",
                                  borderBottom: "10px solid transparent",
                                  borderLeft: "10px solid #ffffff",
                                  filter: "drop-shadow(2px 0px 1px rgba(0,0,0,0.1))",
                                }}
                        />
                                                  <GetStartedPopup
                                title="Accept Waitlisted Appointments"
                           bullets={[
                                  <>
                                    To confirm waitlisted appointments, click on the
                                    "Accept Appointment" icon.
                                  </>,
                                  <>
                                    You will be navigated to the "Schedule
                                    <br />
                                    Appointment" popup with details intact.
                                  </>
                                ]}
                                currentStep={6}
                                totalSteps={8}
                                onBack={() => {
                                  history.push(
                                    "/schedule/calender?step=waitlist5&accountSetupWaitlist=true&openNewAppt=true"
                                  );
                                }}
                                onNext={() => {
                                  history.push({ search: "?step=waitlist7&accountSetupWaitlist=true" });
                                }}
                                onClose={() => history.push({ search: "" })}
                                                                width="310px"

                              />
                               </div>
                          ) : null;
                        })()}
                        {popupStep === "waitlist6" && index === 0 ? (
                                                  <img
                                                    ref={waitlistCalendarIconRef}
                                                    src={waitlistCalendar}
                                                    alt="accept"
                                                    className="waitlist-step6-active-icon"
                                                    style={{ cursor: "pointer", position: "relative", zIndex: 1061 }}
                                                    onClick={() => {
                                                      handleAcceptAppointment(appointment);
                                                      history.push({ search: "?step=waitlist7&accountSetupWaitlist=true" });
                                                    }}
                                                    title="Accept Appointment"
                                                  />
                        ) : (
                          <img
                            src={waitlistCalendar}
                            alt="accept"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleAcceptAppointment(appointment);
                              if (popupStep === "waitlist6") {
                                history.push({ search: "?step=waitlist7&accountSetupWaitlist=true" });
                              }
                            }}
                            title="Accept Appointment"
                          />
                        )}
                      </div>
                    </TableBodyCell>
                  </TableRow>
                ))
              : !loading && (
                  <TableRow className="bot_border">
                    <TableBodyCell className="t-a-c" colSpan={10}>
                      <Div className="img_top text-center p-4">
                        <Image
                          height="133px"
                          width="133px"
                          src={Emp_data_pic}
                        />
                        <Div style={{ marginTop: "16px", color: "#718096" }}>
                          No waitlist appointments found
                        </Div>
                      </Div>
                    </TableBodyCell>
                  </TableRow>
                )}
          </TableBody>
        </Table>
      </Div>

      {/* Load More Button */}
      {displayData.length > 0 && hasMore && (
        <div
          className="loading-more loadMore_btn text-center mt-3"
          style={{ display: showLoading }}
        >
          <Button
            variant="primary"
            className="loading-more-div"
            onClick={loadMoreData}
            disabled={loadFlag === 1 || !hasMore}
          >
            {loadFlag === 1 ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Loading...
              </>
            ) : (
              `Load More`
            )}
          </Button>
        </div>
      )}
      {/* Success Modal */}
      <Modal
        className="alert-popup-message"
        show={successModalAlertShow}
        onHide={() => setSuccessModalAlertShow(false)}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          <span style={{ fontSize: 20, marginLeft: "10px" }}> {alertMsg}</span>
        </div>
      </Modal>

      <Modal
        className="alert-popup-message eramsg"
        show={modalAlertShow}
        onHide={() => setModalAlertShow(false)}
      >
        <div role="alert" className="alert-danger erapad">
          <BsExclamationOctagon
            className="icons-bs"
            style={{ marginBottom: 4, marginRight: 5 }}
          />
          <span style={{ fontSize: 20 }}> {alertMsg}</span>
        </div>
      </Modal>

      {/* Waitlist Modal */}
      <Modal
        show={showAddModal}
        onHide={() => {
          dispatch(
            openToModifyWaitlist({
              data: {},
              value: false,
            }),
          );
          setAddModalShow(false);
        }}
        size="lg"
      >
        <WaitlistModal
          setAddModalShow={setAddModalShow}
          dataFetch={dataFetch}
          id={editId}
          row={editData}
          setSuccessAlertShow={setSuccessAlertShow}
          setSuccessMsg={setSuccessMsg}
        />
      </Modal>
      <Modal
        className="alert-popup-message"
        show={successAlertShow}
        onHide={() => setSuccessAlertShow(false)}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {successMsg}
        </div>
      </Modal>
      <Modal
        show={showNewApptPopup}
        onHide={() => {
          setShowNewApptPopup(false);
          setNewApptData(null);
        }}
        centered
        className="app-popup pat-crt-appt popup_centre custom-modal-width"
      >
        <NewAppointment
          fromWaitList={true}
          waitlistData={newApptData}
          closepopup={() => {
            setShowNewApptPopup(false);
            setNewApptData(null);
          }}
          savealertmsg={(msg, success) => {
            if (success) {
              setAlertMsg(msg);
              setSuccessModalAlertShow(true);

              // Delete the waitlist entry after successful appointment creation
              if (newApptData?.waitlist_id) {
                deleteWaitlistEntry(newApptData.waitlist_id);
              }

              setTimeout(() => {
                setSuccessModalAlertShow(false);
                firstLoadWaitlistData();
              }, 2000);
            } else {
              setAlertMsg(msg);
              setModalAlertShow(true);
            }
          }}
          popuphide={() => {
            setShowNewApptPopup(false);
            setNewApptData(null);
          }}
          FetchAppointments={firstLoadWaitlistData}
          provarray={[]}
          facarray={[]}
          appFromDate={fromDate}
          apptoDate={toDate}
          pat_share={false}
          examroom={false}
          type="waitlist"
        />
      </Modal>
    </>
  );
};

export default memo(WaitlistTable);
